import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=4cfec332&"
import script from "./Learning.vue?vue&type=script&lang=js&"
export * from "./Learning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports